// Upload categories for chat message media files
export const CHAT_MESSAGE_IMAGE = "chat-message-image";
export const CHAT_MESSAGE_VIDEO = "chat-message-video";
export const CHAT_MESSAGE_DOCUMENT = "chat-message-document";
export const CHAT_MESSAGE_AUDIO = "chat-message-audio";

// Helper function to get category from file type
export const getCategoryFromFileType = (file) => {
  if (!file || !file.type) {
    return CHAT_MESSAGE_DOCUMENT; // default to document
  }

  if (file.type.startsWith("image/")) {
    return CHAT_MESSAGE_IMAGE;
  } else if (file.type.startsWith("video/")) {
    return CHAT_MESSAGE_VIDEO;
  } else if (file.type.startsWith("audio/")) {
    return CHAT_MESSAGE_AUDIO;
  } else {
    return CHAT_MESSAGE_DOCUMENT;
  }
};

export const POST_IMAGE = "post-image";
export const POST_VIDEO = "post-video";
export const POST_DOCUMENT = "post-document";

export const getPostCategoryFromFileType = (file) => {
  if (!file || !file.type) {
    return POST_DOCUMENT;
  }

  if (file.type.startsWith("image/")) {
    return POST_IMAGE;
  } else if (file.type.startsWith("video/")) {
    return POST_VIDEO;
  } else {
    return POST_DOCUMENT;
  }
};
